export const FalseCeilingOverviewTabs = {
  leftBar: [
    {
      id: 'falseCeiling',
      label: 'False Ceiling',
      options: [
        {
          id: 'type',
          label: 'Type*',
          type: 'option',
          options: ['Plain False Ceiling', 'False Ceiling']
        },
        {
          id: 'materials',
          label: 'Materials*',
          type: 'option',
          options: ['Gypsum Ceiling - Standard', 'Gypsum Ceiling - Value']
        },
        {
          id: 'design_type',
          label: 'Design Type*',
          type: 'option',
          options: ['Standard', 'Value']
        }
      ],
    },
    {
      id: 'airCondition',
      label: 'Air Condition',
      options: [
        {
          id: 'ac_type',
          label: 'AC Type*',
          type: 'option',
          options: ['Split AC', 'Cassette AC', 'Ductable Unit']
        },
        {
          id: 'cut_out_drop_size',
          label: 'Enter Cut out/ Drop Size (mm)*',
          type: 'input',
          value: 'Length'
        }
      ]
    },
    // {
    //   id: 'scopeOfWork',
    //   label: 'Scope of Work',
    //   options: [
    //     {
    //       id: 'false_ceiling_by',
    //       label: 'False Ceiling by* ',
    //       type: 'option',
    //       options: ['HomeLane', 'Customer']
    //     },
    //   ],
    // }
  ],
  paintDetails: [
    {
      id: 'specifications_finish',
      label: 'Specifications for Finish (*Mandatory)',
      options: [
        {
          id: 'paint_shade_1',
          label: 'Paint Shade 1:*',
          type: 'input',
        },
        {
          id: 'paint_shade_2',
          label: 'Paint Shade 2:',
          type: 'input',
        },
        {
          id: 'paint_process',
          label: 'Paint Process:*',
          type: 'input',
        },
        {
          id: 'texture_paint_1',
          label: 'Texture Paint 1:',
          type: 'input',
        },
        {
          id: 'texture_paint_2',
          label: 'Texture Paint 2:',
          type: 'input',
        },
        {
          id: 'wallpaper',
          label: 'Wallpaper',
          type: 'input',
        },
      ]
    }
  ]
}

export const FalseCeilingPlanTabs = {
  leftBar: [
    {
      id: 'legend',
      label: 'Legend (Electrical)',
    },
    // {
    //   id: 'sow_hl_scope',
    //   label: 'SOW in HL Scope',
    //   sub_label: true,
    //   options: [
    //     {
    //       id: 'false_ceiling',
    //       label: 'False Ceiling',
    //     },
    //     {
    //       id: 'painting',
    //       label: 'Painting',
    //     },
    //     {
    //       id: 'ply_support',
    //       label: 'Ply Support',
    //       type: 'option',
    //       options: ['False Ceiling', 'Painting', 'Ply Support', 'Floor Covering']
    //     },
    //     {
    //       id: 'floor_covering',
    //       label: 'Floor Covering',
    //     },
    //   ],
    // },
  ],
  rightBar: {
    id: 'false_ceiling_quantity_table',
    label: 'False Ceiling Quantity Table',
    options: [
      {
        id: 'horizontal_panel',
        label: 'Horizontal Panel (Sq.ft):',
        type: 'input',
        value: ''
      },
      {
        id: 'grid_ceiling',
        label: 'Grid Ceiling (Sq.ft):',
        type: 'input',
        value: ''
      },
      {
        id: 'floor_covering',
        label: 'Floor Covering (Sq.ft):',
        type: 'input',
        value: ''
      },
      {
        id: 'vertical_panel',
        label: 'Vertical Panel (Rft):',
        type: 'input',
        value: ''
      },
      {
        id: 'vertical_with_cove',
        label: 'Vertical with Cove (Rft):',
        type: 'input',
        value: ''
      },
      {
        id: 'rafter_length',
        label: 'Rafter Length (Rft):',
        type: 'input',
        value: ''
      },
      {
        id: 'modular_grid',
        label: 'Modular Grid (Qty):',
        type: 'input',
        value: ''
      },
    ]
  }
}

export const FalseCeilingLightLayout = {
  leftBar: [
    {
      id: 'legend',
      label: 'Legend (Electrical)',
    },
    // {
    //   id: 'sow_hl_scope',
    //   label: 'SOW in HL Scope',
    //   sub_label: true,
    //   options: [
    //     {
    //       id: 'light_supply',
    //       label: 'Light Supply',
    //     },
    //     {
    //       id: 'fan_supply',
    //       label: 'Fan Supply',
    //     },
    //     {
    //       id: 'extended_fan_rod_supply',
    //       label: 'Extended fan rod supply',
    //     },
    //     {
    //       id: 'switch_sockets',
    //       label: 'Switch & Sockets',
    //     },
    //   ],
    // }
  ],
  rightBar: {
    id: 'Lighting Layout',
    label: 'Lighting Product Quantity Table',
    options: [
      {
        id: 'spot',
        label: 'Spot lights (nos):',
        type: 'input',
        value: ''
      },
      {
        id: 'panel',
        label: 'Panel Lights (nos):',
        type: 'input',
        value: ''
      },
      {
        id: 'pendant',
        label: 'Pendant Light (nos):',
        type: 'input',
        value: ''
      },
      {
        id: 'strip',
        label: 'Strip Light (nos):',
        type: 'input',
        value: ''
      },
      {
        id: 'driver',
        label: 'Driver (nos):',
        type: 'input',
        value: ''
      },
      {
        id: 'chandelier',
        label: 'Chandelier (nos):',
        type: 'input',
        value: ''
      },
      {
        id: 'profile',
        label: 'Profile (nos):',
        type: 'input',
        value: ''
      },
      {
        id: 'track',
        label: 'Track (nos):',
        type: 'input',
        value: ''
      },
      {
        id: 'tracklight',
        label: 'Track Light (nos):',
        type: 'input',
        value: ''
      },
    ]
  }
}

export const FalseCeilingLoopingLayout = {
  leftBar: [
    // {
    //   id: 'sow_hl_scope',
    //   label: 'SOW in HL Scope',
    //   sub_label: true,
    //   options: [
    //     {
    //       id: 'looping',
    //       label: 'Looping',
    //     },
    //     {
    //       id: 'creating_adding_points',
    //       label: 'Creating / Adding Points',
    //     },
    //     {
    //       id: 'switch_switch_box_supply',
    //       label: 'Switch / Switchbox supply'
    //     },
    //     {
    //       id: 'light_installation',
    //       label: 'Light Installation',
    //     },
    //   ],
    // },
    // {
    //   id: 'sow_hl_scope',
    //   label: 'SOW in HL Scope',
    //   sub_label: true,
    //   options: [
    //     {
    //       id: 'fan_installation',
    //       label: 'Fan Installation'
    //     },
    //   ],
    // },
  ],
}

export const FalseCeilingSOW = {
  summaryOptions: {
    id: 'sow_custom_options',
    type: ['Spot Light', 'Panel Light', 'Decorative Light', 'Profile', 'Cove Light', 'Strip for Profile', 'Driver for Strip / Cove', 'Track', 'Track Light', 'Fan', 'Extended fan rod'],
    brand: '',
    qty: ['1', '2', '3'],
    uom: ['Nos', 'Meter'],
  },
  electricSOW: [
    {
      id: 'light_installation_by',
      label: 'Light Installation by',
      type: 'option',
      brand: ['HomeLane', 'Customer', 'Existing']
    },
    {
      id: 'fan_point',
      label: 'Fan Point',
      type: 'option',
      brand: ['HomeLane', 'Customer', 'Existing'],
      typeName: ['Existing', 'Creating', 'Shifting']
    },
    {
      id: 'wiring_looping_by',
      label: 'Wiring / Looping by',
      type: 'option',
      brand: ['HomeLane', 'Customer', 'Existing']
    },
    {
      id: 'fan_rod_installation',
      label: 'Fan & Fan Rod Installation',
      type: 'option',
      brand: ['HomeLane', 'Customer', 'Existing']
    },
    {
      id: 'switch_box',
      label: 'Creation of Switch box / Addition of point',
      type: 'option',
      brand: ['HomeLane', 'Customer', 'Existing']
    },
    {
      id: 'fan_rod_size',
      label: 'Ext. Fan Rod Size',
      type: 'option',
      // typeName: ['HomeLane', 'Customer', 'Existing'],
      brand: [`1'0"`, `1'6"`, `2'0"`]
    },
    {
      id: 'switch_plates',
      label: 'Supply of Switch plates / switches',
      type: 'option',
      brand: ['HomeLane', 'Customer', 'Existing']
    },
    {
      id: 'fan_rod_color',
      label: 'Colour, Supply:',
      type: 'option',
      brand: ['HomeLane', 'Customer', 'Existing'],
      typeName: ['White', 'Brown', 'Beige']
    },
    {
      id: 'floor_covering:',
      label: 'Floor Covering:',
      type: 'option',
      brand: ['HomeLane', 'Customer', 'Existing']
    },
    {
      id: 'fan_supply',
      label: 'Fan Supply',
      type: 'option',
      brand: ['HomeLane', 'Customer', 'Existing']
    },
  ],
}

export const CustomerFalseCeilingTypes = ['CUSTOM_FALSECEILING_OVERVIEW', 'CUSTOM_FALSECEILING_PLAN', 'CUSTOM_FALSECEILING_SECTION', 'CUSTOM_FALSECEILING_ELECTRICAL_SOW', 'CUSTOM_FALSECEILING_LIGHT_LAYOUT', 'CUSTOM_FALSECEILING_LOOPING_LAYOUT', 'CIVIL_WORK', 'DEMOLITION_ROOM', 'CIVIL_FLOOR_MARBLE_LAYING', 'CIVIL_FLOOR_TILE_LAYING', 'CIVIL_WALL_TILE_LAYING', 'WALL_ELECTRICAL', 'CABINET_LIGHT', 'WALL_DECOR_NEW', 'WOODEN_FLOORING', 'CUSTOM_SCOPE_OF_WORK_TABLE', 'CURTAINS', 'CURTAINS_YELLOW', 'CURTAINS_DECOR', 'CURTAINS_AUMBRE', 'COUNTER_TOP_MATERIAL_SOW', 'RFQ'];

// HDS Service
export const HDSPageSeparation = {
  wall_decor: ['WALL_DECOR', 'WALL_DECOR_PAINTING', 'WALL_DECOR_NEW', 'WALLPAPERSERVICE', 'WALL_DECOR_WALLPAPER', 'painting-elevation', 'paintingservice', 'wallpaperservice'],
  plumbing: ['PLUMBING', 'PLUMBINGSERVICES', 'elevation-plumbing', 'plumbingservices'],
  civil: ['CIVIL_WORK', 'CIVIL_FLOOR_MARBLE_LAYING', 'CIVIL_FLOOR_TILE_LAYING', 'CIVIL_WALL_TILE_LAYING', 'civil-work', 'civil_work', 'demolition'],
  demolition: ['DEMOLITION', 'DEMOLITION_QUANTITIES', 'DEMOLITION_ROOM'],
  False_ceiling: ['FALSECEILING', 'CUSTOM_FALSECEILING_OVERVIEW', 'CUSTOM_FALSECEILING_PLAN', 'CUSTOM_FALSECEILING_SECTION', 'CUSTOM_FALSECEILING_ELECTRICAL_SOW', 'CUSTOM_FALSECEILING_LIGHT_LAYOUT', 'CUSTOM_FALSECEILING_LOOPING_LAYOUT', 'FALSECEILING_OVERVIEW', 'FALSECEILING_PLANVIEW', 'FALSECEILING_SECTIONVIEW', 'FALSECEILING_REFLECTEDVIEW', 'FALSECEILING_PAINTVIEW', 'FALSECEILING_LIGHTINGVIEW', 'FALSECEILING_ELECTRICALVIEW', 'FALSECEILING_ELECTRICAL_LOOPINGVIEW', 'falseceiling', 'CUSTOM_SCOPE_OF_WORK_TABLE'],
  electrical_services: ['electricalservices', 'ELECTRICAL', 'WALL_ELECTRICAL' ,'elevation-electricals', 'wall_electrical', 'wallpaper-elevation'],
  counter_top: ['COUNTERTOPMATERIAL&SERVICES', 'COUNTERTOP' ,'countertopmaterial&services', 'countertop'],
  bespoke: ['BESPOKE'],
  flooring:['FLOORINGSERVICE', 'WOODEN_FLOORING', 'FLOORING' ,'flooring'], 
  renovation: ['renovation'],
  rfq:['RFQ']
};
            